/**
 * هر چند وقت یک بار از سرور بپرسیم «خبر تازه‌ای هست؟».
 *
 * منطقِ خالص و مشترکِ هر دو اپ — یک عدد و یک شرط، ولی عددی که دو بار
 * گران تمام شده، پس در یک جا می‌ماند و آزموده می‌شود.
 *
 * ═══ سه لایه، از تندترین به کندترین ═══
 *
 *   ۱. **کانالِ Realtime** — همان لحظه که ردیفی برایت درج می‌شود. تا وقتی
 *      اپ/تب باز است، این همه‌ی کار را می‌کند.
 *   ۲. **پوش** — وقتی اپ بسته است. روی موبایل تریگرِ دیتابیس (مایگریشن
 *      ۰۰۱۱) و تابعِ `notify-push`؛ روی وب اعلانِ مرورگر.
 *   ۳. **نظرسنجی** — همین فایل. توری ایمنی، برای وقتی یکی از آن دو گم شود.
 *
 * لایه‌ی سوم توری ایمنی است، نه بارِ اصلی. هر بار که فاصله‌اش به ثانیه رفته،
 * لایه‌ی سوم عملاً بارِ اصلی شده و دو تای دیگر بی‌مصرف:
 *
 * ⚠ **وب، لاگِ ۲۰۲۶-۰۸-۱۸..۲۰** — با فاصله‌ی ۲۰ ثانیه یک تبِ رهاشده
 *   **۳۵۹۵ بار** پرسید؛ حدودِ ۱۷۰ بار در هر ساعت، تمامِ شب، وقتی هیچ‌کس پای
 *   دستگاه نبود. آن یک نشست به‌تنهایی ۷۷٪ کلِ زمانِ کوئری‌های آن سه روز بود.
 *
 * ⚠ **موبایل، لاگِ ۲۰۲۶-۰۸-۲۷** — همان ۲۰ ثانیه، ولی این بار در **دو**
 *   هوکِ جدا که هر دو به همان جدول می‌زدند (`useNotifIndicators` برای نقطه‌ی
 *   قرمز و `usePushRegistration` برای نشان دادنِ اعلانِ داخلِ اپ). یعنی شش
 *   درخواست در دقیقه: `notifications.select` در یک نشست **۲۱۰ بار**، و ۳۰۰
 *   بار در دوازده نشست. روی گوشی این فقط کوئری نیست — هر بار رادیوی موبایل
 *   از خواب بیدار می‌شود، که گران‌ترین بخشِ ماجراست و مستقیم از باتری و
 *   حجمِ اینترنتِ کاربر خرج می‌کند.
 *
 * موبایل دیرتر اصلاح شد چون کامنتِ بالای `usePushRegistration` سال‌ها گفته
 * بود پوشِ سمتِ سرور «هنوز راه نیفتاده» — که از مایگریشن ۰۰۱۱ به بعد دیگر
 * درست نبود، ولی حلقه‌ای که برای آن دوره گذاشته شده بود سرِ جایش ماند.
 */

/**
 * وقتی پوش هست، هنوز هم گاهی می‌پرسیم — پوش تضمینِ تحویل نیست و کانالِ
 * زنده هم فقط تا وقتی اپ/تب باز است کار می‌کند.
 */
export const POLL_PUSH_MS = 15 * 60_000;
/** و وقتی نیست، تنها راهِ باخبر شدن همین است، پس تندتر. */
export const POLL_FALLBACK_MS = 5 * 60_000;

export const pollInterval = (pushOn: boolean): number =>
  (pushOn ? POLL_PUSH_MS : POLL_FALLBACK_MS);
